import { useCallback } from 'react';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';

const useGeneratePDF = (Order, Marker, Cutrows, sizevariantOptions, totalQuantities, grandTotal, Suborder) => {
  const handleGeneratePDF = useCallback(() => {
    const doc = new jsPDF();
    doc.setFontSize(8);

    const formatDate = (date) => {
      const d = new Date(date);
      return isNaN(d.getTime()) ? 'Invalid Date' : d.toLocaleDateString('en-GB');
    };

    console.log(Suborder[0].colour_name)
    const col1LabelX = 10;
    const col1ValueX = 30;

    const col2LabelX = 85;
    const col2ValueX = 100;

    const col3LabelX = 130;
    const col3ValueX = 145;

    let yPosition = 20;

    const details = [
      { label: 'Buyer Name', value: Order.buyer_name },
      { label: 'Po No', value: Order.pono },
      { label: 'Order No', value: Order.cutorderno },
      { label: 'Colour', value: Suborder[0].colour_name },
      { label: 'Total Piece', value: Suborder[0].total_piece },
      { label: 'Order Date', value: formatDate(Order.orderdate) },
      { label: 'Style', value: Order.style_name },
      { label: 'Delivery Date', value: formatDate(Order.delivery_date) },
    ];

    // Loop 3 per row
    for (let i = 0; i < details.length; i += 3) {
      const col1 = details[i];
      const col2 = details[i + 1];
      const col3 = details[i + 2];

      if (col1) {
        doc.text(`${col1.label}:`, col1LabelX, yPosition);
        doc.text(String(col1.value || "N/A"), col1ValueX, yPosition);
      }

      if (col2) {
        doc.text(`${col2.label}:`, col2LabelX, yPosition);
        doc.text(String(col2.value || "N/A"), col2ValueX, yPosition);
      }

      if (col3) {
        doc.text(`${col3.label}:`, col3LabelX, yPosition);
        doc.text(String(col3.value || "N/A"), col3ValueX, yPosition);
      }

      yPosition += 10;
    }

    const boxX = 184;
    const boxY = 1;
    const boxWidth = 25;
    const boxHeight = 25;

    doc.rect(boxX, boxY, boxWidth, boxHeight); // draw the box
    doc.text("Stab Fabric", boxX + 5, boxY + 8); // title
    doc.text("Material", boxX + 5, boxY + 15);   // subtitle


    yPosition += 10;
    doc.setFontSize(12);



    doc.autoTable({
      startY: yPosition,
      head: [
        ["Size", ...Object.keys(Suborder[0].size_variant_quantity)]
      ],
      body: [
        ["Quantity", ...Object.values(Suborder[0].size_variant_quantity)]
      ],
      theme: 'grid',
      margin: { top: 30, left: 10, right: 10, bottom: 20 },
    });



    const firstTableHeight = doc.lastAutoTable.finalY;

    doc.autoTable({
      startY: firstTableHeight + 20,
      head: [
        ['Cutting No', 'Layer Length', 'No. of Layers', 'Size Variant', 'Total Variant', 'Total Piece', 'Total Fabric', 'Avg CMP Per GMT']
      ],
      body: Cutrows.map((row) => [
        row.cuttingNo,
        row.layerLen,
        row.noLayers,
        Object.entries(row.sizevariant)
          .map(([sizeId, quantity]) => {
            const marker = Marker.find((m) => m.size_id == parseInt(sizeId));
            return marker ? `${marker.size}(${quantity})` : '';
          })
          .filter((label) => label)
          .join(', '),
        row.totalvariant,
        row.totalpiece,
        row.totalFabric,
        row.Avgcmp,
      ]),
      theme: 'grid',
      margin: { top: 30, left: 10, right: 10, bottom: 20 },
    });

    const secondTableHeight = doc.lastAutoTable.finalY;

    doc.autoTable({
      startY: secondTableHeight + 20,
      head: [
        ['Size', ...sizevariantOptions.map((option) => option.label), 'Total']
      ],
      body: [
        ['Quantity', ...sizevariantOptions.map((option) => totalQuantities[option.label]), grandTotal],
      ],
      theme: 'grid',
      margin: { top: 30, left: 10, right: 10, bottom: 20 },
    });

    doc.save(`${Order.cutorderno}.pdf`);
  }, [Order, Marker, Cutrows, sizevariantOptions, totalQuantities, grandTotal, Suborder]);

  return handleGeneratePDF;
};

export default useGeneratePDF;
